import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FinishPosition } from '../HorseCard/HorseCard.types';
import { isGeneralTab, isResultTab } from './TabMenuItem.functions';
import './TabMenuItem.scss';
import { addSuffix } from '../../common/ordinals';
import GradientBorder from '../GradientBorder/GradientBorder';

export type TabText = number | 'my-selections' | 'payout-table';

export interface TabMenuItemGeneral {
  type: 'general';
  tabText: TabText;
  selectionMade: boolean;
  focused: boolean;
  onClick?: (tab: TabText) => void;
}

export interface TabMenuItemResult {
  type: 'result';
  tabText: number;
  position: FinishPosition | undefined;
  selectionResult: string;
}

export type TabMenuItemProps = TabMenuItemGeneral | TabMenuItemResult;

const TabMenuItem = (props: TabMenuItemProps) => {
  if (isGeneralTab(props)) return <GeneralTab {...props} />;
  if (isResultTab(props)) return <ResultTab {...props} />;
  return null;
};
export default TabMenuItem;

const ResultTab = ({ tabText, position, selectionResult }: TabMenuItemResult) => {
  const { t } = useTranslation();
  const isNotPlaced = selectionResult === '-';
  let className = '';
  if (selectionResult === 'W') className = 'win';
  else if (isNotPlaced) className = 'not-placed';
  if (!position && !isNotPlaced) position = '-';
  return (
    <div className={`result-tab-item`}>
      <div className='result-tab-item__race-number'>{t('race-number', { raceNo: tabText })}</div>
      <GradientBorder name={`result-tab-item ${className}`}>
        <div className={`result-tab-item__position ${className}`}>
          <div className={'result-tab-item__position__text'}>
            {typeof position === 'number' ? t(addSuffix(position)) : position}
          </div>
        </div>
      </GradientBorder>
    </div>
  );
};

const GeneralTab = ({ tabText, selectionMade, focused, onClick }: TabMenuItemGeneral) => {
  const { t } = useTranslation();
  const selectedClass = selectionMade ? 'selection-made' : '';
  const focusedClass = focused ? 'focused' : '';
  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // scrollIntoView throws errors when called form unit tests
    if (!focused || !itemRef.current?.scrollIntoView) return;
    itemRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }, [focused]);

  return (
    <div
      ref={itemRef}
      onClick={() => {
        onClick?.(tabText);
      }}
      className={`tab-menu-item ${focusedClass} ${selectedClass}`}
    >
      {selectionMade && <div className='icon' />}
      {typeof tabText === 'number' ? t('race-number', { raceNo: tabText }) : t(tabText)}
    </div>
  );
};
